import _ from 'lodash';
import Signals from 'signals';
    

    function DashboardModel() {
        var self = this;
        self.panels = [];
        //  TODO: change 'signals' to "simple" observables as in 'observable-factory.ts'
        self.panelsUpdated = new Signals.Signal();
    }

    DashboardModel.prototype = {
        getPanels: function () {
            var self = this;
            return _.cloneDeep(self.panels);
        },

        setPanels: function (panels) {
            var self = this;
            self.panels = _.cloneDeep(panels);
            self.panelsUpdated.dispatch();
        },

        updatePanelPositions: function (newPanels) {
            var self = this;
            _.forEach(newPanels, function (panel) {
                var found = _.find(self.panels,  ['id', panel.id]);
                if (found) {
                    found.x = panel.x;
                    found.y = panel.y;
                }
            });
        },

        updatePanelOptions: function(updatedOptions) {
            var self = this;
            var found = _.find(self.panels,  ['id', updatedOptions.id]);
            if (found) {
                _.assign(found.params.options, updatedOptions.params.options);
            }
        },

    };

    export default DashboardModel;

